<template>
  <div class="px-4 pt-3">
    <validateMatchModal
      :productToEdit="selectedProductToAction"
      :matchesList="matchesList"
      :pagination="pagination"
      :filter="searchParams"
      :show="show_validate_modal"
      :component_name="component_name"
      @show-notification="showNotification"
      @callback-function="dataChanged"
    />
    <deleteMatchModal
      :ProductToDelete="selectedProductToAction"
      :show="show_delete_modal"
      :component_name="component_name"
      @callback-function="dataChanged"
    />
    <deleteMatchModalMultiple
      :ProductsToDelete="selectedMatchs"
      :show="show_delete_modal_multiple"
      :component_name="component_name"
      @callback-function="dataChanged"
    />
    <editMatchModalCustom
      :ProductToEdit="selectedProductToAction"
      :show="show_edit_modal"
      :component_name="component_name"
      @confirm-edit="dataChanged"
      @show-notification="showNotification"
      v-if="user_website.id == source_id"
    />
    <editMatchModal
      :ProductToEdit="selectedProductToAction"
      :show="show_edit_modal"
      :component_name="component_name"
      @confirm-edit="dataChanged"
      @show-notification="showNotification"
      v-else
    />
    <!-- This is the exportation modal, to choose which websites you didn't want to export-->
    <exportModal
      :show="export_modal_opend"
      :component_name="component_name"
      @show-redirect-modal="showRedirectModal()"
    />
    <exportRedirectModal :show="show_redirect_modal" />
    <histogramchart
      :selected_product="selectedProductToAction"
      :component_name="component_name"
      :show="show_histograme_modal"
      @show-validate-modal="showValidateModal"
    />
    <div v-if="showGlobalAccurateDataMessage" class="d-flex justify-center">
      <v-alert prominent type="warning" class="w-50" color="error">
        <v-row align="center">
          <v-col class="grow">
            <div class="md-text">
              Please note that the information displayed on your dashboard may not be fully accurate
              yet.
            </div>
            <div class="md-text">
              We are currently validating your websites and will ensure precise data within the next
              24 hours.
            </div>
          </v-col>
          <v-col class="shrink">
            <v-btn class="text-none" outlined @click="hideGlobalAccurateDataMessage">Hide</v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </div>
    <div v-if="false" class="d-flex justify-center">
      <!-- <div v-if="showGlobalAddProductsMessage" class="d-flex justify-center"> -->
      <v-alert prominent type="info" class="w-50">
        <v-row align="center">
          <v-col class="grow">
            <div class="md-text">Start by creating your first product list</div>
            <div class="md-text">You can import products from an xlsx or csv file</div>
          </v-col>
          <v-col class="shrink">
            <router-link to="importations">
              <v-btn class="text-none" color="error" outlined>Add Products</v-btn>
            </router-link>
          </v-col>
        </v-row>
      </v-alert>
    </div>
    <div v-if="match_length.list_length">
      <v-row>
        <v-col cols="12">
          <div class="d-flex align-center mb-4">
            <h1 class="text-h4 font-weight-bold grey--text text--darken-3">Analytics Overview</h1>
          </div>
          <filterInputs @load-data="dataChanged" :component_name="component_name" />
          <GlobalStats ref="globalStats" />
          <h2 class="text-h6 mb-3 mt-4">Market Analysis</h2>
          <v-row>
            <v-col cols="12" md="6">
              <chartcardpriceindex ref="priceIndexChart" :component_name="component_name" />
            </v-col>
            <v-col cols="12" md="6">
              <chartcarddistribution
                ref="distributionChart"
                :component_name="component_name"
                :disable_filter="true"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <chartcardpricingstatus ref="pricingStatusChart" :component_name="component_name" />
            </v-col>
            <v-col cols="12" md="6">
              <chartcardavailability ref="availabilityChart" :component_name="component_name" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <div v-else class="d-flex justify-center mt-10">
      <Importation
        :showRecentImportations="false"
        mainTitle="No Product Yet!"
        subTitle="Start by creating your first product list to get started."
        @onImportSuccess="() => refresh()"
      />
    </div>
    <snackbar :show="snackbar" :color="snackbar_color" :msg="snackbar_msg" :icon="snackbar_icon" />
  </div>
</template>

<script>
  import axios from 'axios'
  import histogramchart from '../common/histogramChart'
  import exportModal from '../Exportation/exportModal.vue'
  import exportRedirectModal from '../common/exportRediretModal.vue'
  //import comparePricesTable from '../common/comparePricesTable.vue'
  //import simpleComparePricesTable from '../common/simpleComparePricesTable.vue'
  import chartcardpricingstatus from '../common/chartPricingStatus'
  import chartcardavailability from '../common/chartCardAvailability'
  import chartcarddistribution from '../common/chartCardDistribution'
  import chartcardpriceindex from '../common/charCardPriceIndex'
  import deleteMatchModal from '../common/deleteMatchModal.vue'
  import deleteMatchModalMultiple from '../common/deleteMatchModalMultipl.vue'
  import editMatchModal from '../common/editMatchModal.vue'
  import editMatchModalCustom from '../common/editMatchModalCustom.vue'
  //import filterInputs from '../common/filterInputs.vue'
  import validateMatchModal from '../common/validateMatchModal.vue'
  import Importation from '../Importation/Importation.vue'
  import GlobalStats from '../common/GlobalStats.vue'
  import filterInputs from '../common/filterInputs.vue'

  export default {
    name: 'Analytics',
    components: {
      Importation,
      histogramchart,
      exportModal,
      exportRedirectModal,
      //comparePricesTable,
      //simpleComparePricesTable,
      chartcardpricingstatus,
      chartcardavailability,
      chartcarddistribution,
      chartcardpriceindex,
      deleteMatchModal,
      deleteMatchModalMultiple,
      editMatchModal,
      editMatchModalCustom,
      filterInputs,
      validateMatchModal,
      GlobalStats,
    },
    props: {
      msg: String,
    },
    data() {
      return {
        compactTable: true,
        user_website: localStorage.user_website ? JSON.parse(localStorage.user_website) : {},
        source_id: '6019aee744817b0f85ff85bb',
        show_redirect_modal: false,
        snackbar: false,
        snackbar_color: '',
        snackbar_msg: '',
        matches_stats: true,
        snackbar_icon: '',
        loading: false,
        filter: {},
        chartData: {
          data: {
            labels: [],
            datasets: [],
          },
        },
        account_id: localStorage.getItem('account_id'),
        search: '',
        matchs: [],
        allProducts: [],
        selectedProduct: {},
        selectedProductToAction: {
          match_id: '',
          match_ref: '',
          product_brand: '',
          product_name: '',
          product_image: '',
        },
        showProductChart: false,
        websites: {},
        exclude_websites: [],
        remainWebsites: [],
        export_modal_opend: false,
        // lastAvailableDate: "",
        show_histograme_modal: false,
        show_delete_modal: false,
        show_delete_modal_multiple: false,
        show_validate_modal: false,
        total_data: 0,
        data_changed: false,
        selected_price_index: null,
        show_edit_modal: false,
        match_length: { list_length: 1 },
        showGlobalAddProductsMessage: false,
        showGlobalAccurateDataMessage: false,
        component_name: this.$router.history.current.fullPath,
        selectedMatchs: [],
        matchesList: [],
        pagination: {},
        searchParams: {},
      }
    },
    methods: {
      showExportModal() {
        this.export_modal_opend = !this.export_modal_opend
      },
      showRedirectModal() {
        this.show_redirect_modal = !this.show_redirect_modal
      },
      async setUserWebsites() {
        await axios
          .get('/api/websites/list', {
            params: {
              account: this.account_id,
              user: localStorage.getItem('user_id'),
              component: this.component_name,
            },
          })
          .then((res) => {
            localStorage.setItem(`user_website`, JSON.stringify(res.data.account.website))
            localStorage.setItem(`user_websites`, JSON.stringify(res.data.account.websites))
          })
      },
      deleteMatchs() {
        this.show_delete_modal_multiple = !this.show_delete_modal_multiple
      },
      matchsSelected(matchs) {
        this.selectedMatchs = matchs
      },
      confirmDelete(item) {
        this.selectedProductToAction = item
        this.show_delete_modal = !this.show_delete_modal
      },
      showValidateModal(item) {
        this.selectedProductToAction = item.item
        this.matchesList = item.data
        this.pagination = item.pagination
        this.searchParams = item.searchParams
        this.show_validate_modal = !this.show_validate_modal
      },
      showEditModal(item) {
        this.selectedProductToAction = item
        this.show_edit_modal = !this.show_edit_modal
      },
      dataChanged(payload) {
        this.filter = payload
        this.data_changed = !this.data_changed

        if (this.$refs.globalStats) {
          this.$refs.globalStats.fetchStats()
        }
        if (this.$refs.priceIndexChart) {
          this.$refs.priceIndexChart.initHistoryChart()
        }
        if (this.$refs.distributionChart) {
          this.$refs.distributionChart.fetchData()
        }
        if (this.$refs.pricingStatusChart) {
          this.$refs.pricingStatusChart.update()
        }
        if (this.$refs.availabilityChart) {
          this.$refs.availabilityChart.initChart()
        }
      },
      update_filter: function () {
        this.dataChanged()
      },
      showPriceChart(item) {
        this.selectedProductToAction = item
        this.show_histograme_modal = !this.show_histograme_modal
      },
      showNotification(payload) {
        this.snackbar_color = payload.type
        this.snackbar_msg = payload.msg
        this.snackbar = !this.snackbar
        this.snackbar_icon = payload.icon
      },
      hideGlobalAccurateDataMessage() {
        localStorage.setItem('show_ACCURATEDATA_MESSAGE', 'hide')
        this.showGlobalAccurateDataMessage = false
      },
      hideAddProductsMessage() {
        localStorage.setItem('show_PRODUCTS_MESSAGE', 'hide')

        if (this.matches_stats && localStorage.getItem('show_PRODUCTS_MESSAGE') === 'show') {
          this.showGlobalAddProductsMessage = true
        } else {
          this.showGlobalAddProductsMessage = false
        }
      },
      async getMatchsStat() {
        this.match_length = await axios
          .get('/api/products/matchsstat', {
            params: {
              account: this.account_id,
              user: localStorage.getItem('user_id'),
              component: this.component_name,
            },
          })
          .then((res) => {
            return res.data
          })
        if (this.match_length.data_length) this.matches_stats = false
        else this.matches_stats = true

        if (this.matches_stats && localStorage.getItem('show_PRODUCTS_MESSAGE') === 'show') {
          this.showGlobalAddProductsMessage = true
        } else {
          this.showGlobalAddProductsMessage = false
        }

        if (
          this.matches_stats &&
          !this.match_length.list_length &&
          localStorage.getItem('show_ACCURATEDATA_MESSAGE') !== 'hide'
        ) {
          localStorage.setItem('show_ACCURATEDATA_MESSAGE', 'show')
          this.showGlobalAccurateDataMessage = true
        }

        if (
          localStorage.getItem('show_ACCURATEDATA_MESSAGE') == 'show' &&
          this.showGlobalAccurateDataMessage == false
        ) {
          this.showGlobalAccurateDataMessage = true
        } else {
          this.showGlobalAccurateDataMessage = false
        }
      },
      refresh() {
        this.setUserWebsites()
        this.getMatchsStat()
      },
    },
    mounted() {
      this.setUserWebsites()
      this.getMatchsStat()
    },
    created() {
      if (localStorage.getItem('compactTable') == 'true') {
        this.compactTable = true
      } else if (localStorage.getItem('compactTable') == 'false') {
        this.compactTable = false
      } else {
        this.compactTable = true
      }
    },
    watch: {
      compactTable(val) {
        localStorage.setItem('compactTable', val)
      },
    },
  }
</script>

<style scoped>
  .theme--light.v-application {
    background: none !important;
  }
</style>
